import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import BsTag from '../icons/BsTag';
import { any, func, string } from 'prop-types';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';

export default function SearchResultsItemProduct({ query, title, handle, imageUrl, onClick = () => {} }) {
    const productPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.PRODUCT_PATH });

    const handleMatched = (handle, query) => query.replace(/[^0-9-]/g, '') === handle.replace(/[^0-9-]/g, '');

    const highlight = useCallback((word) => {
        if (!query) {
            return false;
        }

        return query.toLowerCase().split(' ').some((element) => {
            if (element === '') {
                return false;
            }

            return word.toLowerCase().includes(element);
        });
    }, [query]);

    return (<li>
        <Link
            onClick={onClick}
            className={'search--results-item search--results-item-link'}
            to={`${productPath[0].pathBeforeParams}/${handle}`}>
            {!imageUrl && (<span
                className={'me-2'}><BsTag
                    size={'25px'} /></span>
            )}
            <div
                className={'search--results-item--inner'}>
                {title?.length > 0 && (<p
                    className={`search--results-item-title ${handleMatched(handle,query) ? 'fw-bold' : ''}`}>{title.split(' ').map((word) => {
                        return (
                            <>
                                <span
                                    className={ highlight(word) ? 'highlight' : ''}
                                    key={word}
                                >
                                    {word}
                                </span>{' '}
                            </>
                        );
                    })}</p>)}
            </div>
        </Link>
    </li>);
}

SearchResultsItemProduct.propTypes = {
    title: string,
    handle: string,
    imageUrl: any,
    onClick: func,
    query: string,
};